
      window.env.googleMapsApiKey = import.meta.env.PROD
        ? "AIzaSyDFS1CKzM9_goNVsMXjrmVfG4Z2HxqA9l0"
        : "AIzaSyCPWF8ji6RGiTctkniA7a0I2Lswh-KcfIk";
    